import { FC, useContext } from 'react';
import { LoginContext } from '../../config/authentication/LoginContext';
import { ResumenBase } from './ResumenBase';

type Props = {
  show?: boolean;
};

export const CorreoResumen: FC<Props> = ({ show }) => {
  const loginData = useContext(LoginContext);

  if (!show || !loginData?.user?.email) return <></>;
  return (
    <ResumenBase>
      Se enviará al e-mail <b>{loginData.user.email}</b>.
    </ResumenBase>
  );
};
